<template>
  <div class="container_box">
    <!--扫描-->
    <div class="options_box">
      <Form :model="scanningForm" ref="scanningForm" class="form_box" :label-width="80" @submit.native.prevent>
        <FormItem :label="$t('key1004003')" prop="scanningInput" style="margin-bottom: 0;">
          <Input
            v-model.trim="scanningForm.scanningInput"
            :element-id="'scanningInput'"
            style="width:350px"
            :placeholder="$t('key1004150')"
            @on-keyup.13="scanningKey"></Input>
        </FormItem>
      </Form>
    </div>
    <!--物流渠道-->
    <div class="logistics_box">
      <div class="logistics_mode">
        <span class="tips">{{ $t('key1004010') }}</span>
        <span class="text">{{ logisticsMode }}</span>
      </div>
      <div class="scan_title">{{ $t('key1001521') + waybillNo }}</div>
    </div>
    <!--列表区域-->
    <div class="tabs_conter_box" v-show="oeliveryOrderData.length >0">
      <Tabs type="card" v-model="ymsCarrierHandoverOrderId" :animated="false" @on-click="changeTabs">
        <TabPane v-for="(item, index) in oeliveryOrderData"
          :key="index"
          :label="(h)=>{
            return h('div',[
              h('p',item.carrierName),
              h('p',{
                style: {
                  'font-size': '12px'
                }
              },item.ukId)
            ])
          }"
          :name="item.ymsCarrierHandoverOrderId">
          <Table
            highlight-row
            border
            max-height="700"
            :columns="oeliveryOrderColumns"
            :data="item.ymsThirdPlatformPackages"></Table>
        </TabPane>
      </Tabs>
      <div class="options_btn">
        <Button type="primary" size="large" :loading="loadingBtn1" @click="printShippingMarkBtn">{{ $t('key1001181') }}</Button>
        <Button type="success" size="large" :loading="loadingBtn2" @click="bagMakingBtn">{{ $t('key1004012') }}</Button>
      </div>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/index';
import Mixin from "@/components/mixin/common_mixin";
import {getQueryCarrierShippingName} from "@/utils/common";

export default {
  name: "choiceSorting",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      scanningForm: {
        scanningInput: ''
      },
      loadingBtn: false,
      loadingBtn1: false,
      loadingBtn2: false,
      waybillNo: '', // 运单号
      logisticsMode: '', // 物流方式
      ymsCarrierHandoverOrderId: '',
      oeliveryOrderData: [],
      oeliveryOrderColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004142'),
          key: 'transferCode',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004143'),
          key: 'carrierHandoverOrder',
          align: 'center',
          render(h, params) {
            let isScan = params.row.carrierHandoverOrder === 1;
            if (isScan) {
              return h('Icon', {
                props: {
                  type: 'md-checkmark-circle',
                  size: '18'
                },
                style: {
                  color: '#19BE6B'
                }
              });
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004144'),
          key: 'userWeight',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004145'),
                    show: !!(params.row.labelPath),
                    clickFn: () => {
                      this.commonPrint(params.row.labelPath, '1');
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
    };
  },
  created() {
    this.getSortingCarrierHandoverOrder();
  },
  methods: {
    // 回车键扫描
    async scanningKey() {
      let v = this;
      if (!v.scanningForm.scanningInput) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004146'));
        return;
      }
      const {data} = await v.axios.put(api.put_ymsCarrierHandoverOrder_startSortingForThirdPlatform + v.scanningForm.scanningInput);
      if (data.code === 0) {
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004147'));
        await v.getSortingCarrierHandoverOrder();
      }
    },
    // 切换tabs
    changeTabs(name) {
      this.ymsCarrierHandoverOrderId = name;
      let data = this.oeliveryOrderData.filter(i => i.ymsCarrierHandoverOrderId === name);
      this.logisticsMode = data[0].carrierName;
      this.waybillNo = data[0].ukId;
    },
    // 打印箱唛
    async printShippingMarkBtn() {
      let v = this;
      if (v.loadingBtn1) return;
      v.loadingBtn1 = true;
      const {data} = await v.axios.put(api.put_ymsCarrierHandoverOrder_printHandoverOrderForThirdPlatform + v.ymsCarrierHandoverOrderId);
      v.loadingBtn1 = false;
      if (data.code === 0) {
        this.commonPrint(data.datas, '1');
      }
    },
    // 结袋
    async bagMakingBtn() {
      let v = this;
      let ymsThirdPlatformPackages = this.oeliveryOrderData.filter(i => i.ymsCarrierHandoverOrderId === v.ymsCarrierHandoverOrderId)[0].ymsThirdPlatformPackages;
      if (ymsThirdPlatformPackages.some(i => i.carrierHandoverOrder !== 1)) {
        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004148'));
        return;
      }
      if (v.loadingBtn1) return;
      v.loadingBtn1 = true;
      const {data} = await v.axios.post(api.post_ymsCarrierHandoverOrder_endSortingForThirdPlatform, {
        type: 1, // 结袋类型 0:结袋打印 1:直接结袋,
        ymsCarrierHandoverOrderId: v.ymsCarrierHandoverOrderId // 交接单号
      });
      v.loadingBtn1 = false;
      if (data.code === 0) {
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
        v.getSortingCarrierHandoverOrder();
      }
    },
    async getSortingCarrierHandoverOrder() {
      let v = this;
      if (v.loadingBtn) return;
      v.loadingBtn = true;
      const {data} = await v.axios.get(api.get_ymsCarrierHandoverOrder_querySortingForThirdPlatform);
      v.loadingBtn = false;
      if (data.code === 0) {
        let packages = data.datas || [];
        if (packages.length > 0) {
          let shippingMethodIds = [...new Set(packages.map(i => i.shippingMethodId))];
          const shippingData = await getQueryCarrierShippingName(shippingMethodIds);
          packages.forEach(i => {
            shippingData.forEach(j => {
              if (i.shippingMethodId === j.shippingMethodId) {
                i.carrierName = j.carrierName;
                i.shippingMethodName = j.shippingMethodName;
              }
            });
          });
          let showData = packages[0];
          v.logisticsMode = showData.carrierName;
          v.waybillNo = showData.ukId;
          v.ymsCarrierHandoverOrderId = showData.ymsCarrierHandoverOrderId;
          v.oeliveryOrderData = packages;
          packages.map((ele) => {
            if (ele.ymsThirdPlatformPackages && ele.ymsThirdPlatformPackages.length > 0) {
              ele.ymsThirdPlatformPackages.map((item) => {
                if (item.transferCode === v.scanningForm.scanningInput) {
                  if (item.labelPath) {
                    v.commonPrint(item.labelPath, '1');
                  } else {
                    v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004149'));
                    return false;
                  }
                }
              });
            }
          });
          v.scanningForm.scanningInput = '';
        } else {
          v.logisticsMode = '';
          v.waybillNo = '';
          v.ymsCarrierHandoverOrderId = '';
          v.oeliveryOrderData = [];
          v.scanningForm.scanningInput = '';
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container_box {
  background-color: #fff;
  padding: 10px;

  .options_box {
    width: 100%;
    margin: 0px auto 30px;
    display: flex;

    .form_box {
      padding: 20px 10px;
      background-color: #DBEBD3;
      margin-right: 100px;

      /deep/ input, /deep/ .ivu-input-number {
        height: 38px;
        line-height: 38px;
      }

      /deep/ .ivu-form-item-label {
        font-size: 16px;
        padding-right: 0 !important;
        color: #333;
      }

      /deep/ .ivu-input-number-handler {
        height: 19px;
      }
    }
  }

  .logistics_box {
    .logistics_mode {
      font-size: 32px;
      margin-bottom: 15px;

      .tips {
        color: #D9001B;
      }
    }

    .scan_title {
      font-size: 29px;
      color: #333;
      margin-bottom: 15px;
    }
  }

  .tabs_conter_box {
    width: 70%;
    height: 820px;
    overflow-y: auto;

    /deep/ .ivu-tabs-bar {
      padding: 0;
      margin-bottom: 15px;
      border-bottom: 1px solid #dcdee2;
    }
  }

  .tabs_conter_box .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav-container,
  .tabs_conter_box .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active,
  .tabs_conter_box .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
    height: 45px;
  }

  .options_btn {
    margin: 40px auto 0;
    display: flex;
    align-items: center;
    width: 300px;

    /deep/ .ivu-btn {
      width: 150px;
      margin: 0 20px;
    }
  }
}
</style>